import React from 'react';

import { CustomDateModal, DropdownInput, } from '../../../Shared';
import { formatDateForInput } from '../../../Shared/components/shared/dateInput';

export const ScorebookFilters = (
  {
    classroomFilters,
    selectedClassroom,
    selectClassroom,
    unitFilters,
    selectedUnit,
    selectUnit,
    beginDate,
    endDate,
    selectDates,
  },
) => {
  const [showCustomDateModal, setShowCustomDateModal] = React.useState<boolean>(false)

  const classroomFilterOptions = classroomFilters.map((c) => {
    c.label = c.name
    return c
  })

  const selectedClassroomOption = classroomFilterOptions.find(c => selectedClassroom ? c.value === selectedClassroom.value : true)

  const activityPackFilterOptions = unitFilters.map((c) => {
    c.label = c.name
    return c
  })

  const selectedActivityPackOption = activityPackFilterOptions.find(c => c.value === selectedUnit.value)

  function openCustomDateModal() {
    setShowCustomDateModal(true)
  }

  function closeCustomDateModal() {
    setShowCustomDateModal(false)
  }

  const timeframeHelperText = beginDate && endDate ? `${formatDateForInput(beginDate)} - ${formatDateForInput(endDate)}` : null

  return (
    <React.Fragment>
      <div className="activity-page-dropdown-wrapper scorebook-filters">
        <div className="scorebook-filter-group">
          <DropdownInput
            ariaLabel="Classroom"
            className="classroom-dropdown-input bordered small focus-on-light"
            handleChange={selectClassroom}
            id="classroom"
            options={classroomFilterOptions}
            value={selectedClassroomOption}
          />
          <DropdownInput
            ariaLabel="Activity pack"
            className="activity-pack-dropdown-input bordered small focus-on-light"
            handleChange={selectUnit}
            id="activity-pack"
            options={activityPackFilterOptions}
            value={selectedActivityPackOption}
          />
        </div>
        <div className="date-filter-button-container">
          <p>{timeframeHelperText}</p>
          <button className="quill-button small grey outlined focus-on-light" onClick={openCustomDateModal}>Filter by date</button>
        </div>
      </div>
      {showCustomDateModal && (
        <CustomDateModal
          close={closeCustomDateModal}
          passedEndDate={endDate}
          passedStartDate={beginDate}
          setCustomDates={selectDates}
          showResetDatesButton={true}
        />
      )}
    </React.Fragment>
  );
};

export default ScorebookFilters;
